const GUMLET_HOSTS = ['vinc.gumlet.io', 'vibooks.gumlet.io']
const DEFAULT_PLACEHOLDER_WIDTH = 40

/**
 * Returns a Gumlet URL with a small width for use as a progressive image placeholder.
 * The browser can load this tiny image directly from Gumlet (no server round-trip).
 * If the URL is not a Gumlet URL, returns the original URL unchanged.
 */
export function getGumletPlaceholderUrl(
  imageUrl: string,
  placeholderWidth: number = DEFAULT_PLACEHOLDER_WIDTH
): string {
  if (!imageUrl?.trim()) return imageUrl

  try {
    const url = new URL(imageUrl)
    if (!GUMLET_HOSTS.includes(url.hostname)) {
      return imageUrl
    }

    url.searchParams.set('w', String(placeholderWidth))
    // Match old server behavior: WebP for small placeholder bytes
    url.searchParams.set('format', 'webp')
    return url.toString()
  } catch {
    return imageUrl
  }
}
